import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { DataTable } from "@ploy-ui/core";
import groupBy from "lodash/groupBy";
import { Typography, Box, Checkbox, Accordion, AccordionSummary, AccordionDetails, Button, CircularProgress } from "@material-ui/core";
import { FormattedNumber } from "react-intl";
const getMonthNameFromIndex = index => {
    var month = new Date(0, index).toLocaleDateString("nb-NO", { month: "long" });
    return month.charAt(0).toUpperCase() + month.substring(1);
};
export const TableStructure = ({ list, groupByLamda, monthly, year, getAdditionalInformation, sendToApproval, getApplicationInformation }) => {
    let grouped = groupBy(list, groupByLamda);
    let tableStructure = Object.entries(grouped)
        .sort(([k1], [k2]) => k2.localeCompare(k1))
        .map(([x, commissions]) => {
        return (_jsx(Box, { children: _jsxs(Accordion, { elevation: 0, defaultExpanded: !monthly, children: [_jsx(AccordionSummary, { expandIcon: _jsx(ExpandMoreIcon, {}), children: _jsx(Typography, { variant: "h6", children: monthly ? getMonthNameFromIndex(x) : x }) }), _jsx(AccordionDetails, { style: { display: "block" }, children: monthly ? (_jsx(CommissionType, { commissions: commissions, monthDate: new Date(Number.parseInt(year), Number.parseInt(x), 1), getAdditionalInformation: getAdditionalInformation, sendToApproval: sendToApproval, getApplicationInformation: getApplicationInformation })) : (_jsx(TableStructure, { list: commissions, groupByLamda: c => isNaN(c.startDate.getMonth())
                                ? c.date.getMonth()
                                : c.startDate.getMonth(), year: x, monthly: true, getAdditionalInformation: getAdditionalInformation, sendToApproval: sendToApproval, getApplicationInformation: getApplicationInformation })) })] }) }, x));
    });
    return _jsx(_Fragment, { children: tableStructure });
};
export const CommissionType = ({ commissions, monthDate, getAdditionalInformation, sendToApproval, getApplicationInformation }) => {
    const [logRetrived, setLogRetrived] = React.useState(false);
    const [retriving, setRetriving] = React.useState(false);
    const [applicationInformation, setApplicationInformation] = React.useState();
    const [sent, setSent] = React.useState([]);
    const [send, setSend] = React.useState([]);
    const [approved, setApproved] = React.useState([]);
    const [declined, setDeclined] = React.useState([]);
    const [message, setMessage] = React.useState("");
    const [loading, setLoading] = React.useState(false);
    const handleCheck = (agreement) => {
        setMessage("");
        if (send.some(x => x.agreementNumber === agreement.agreementNumber))
            setSend(send.filter(x => x.agreementNumber !== agreement.agreementNumber));
        else
            setSend(send.concat(agreement));
    };
    const handleSendToApproval = async () => {
        if (sendToApproval) {
            setLoading(true);
            const response = await sendToApproval(send);
            if (response.success) {
                setMessage("Sendt til avregning");
                setSent(sent.concat(send.map(x => x.agreementNumber)));
            }
            else
                setMessage(response.message);
            setLoading(false);
            setSend([]);
        }
    };
    const handleGetLog = async (agreements) => {
        if (logRetrived || !getAdditionalInformation)
            return;
        const responses = await Promise.all(agreements.map(agreementNumber => getAdditionalInformation(monthDate, agreementNumber)));
        setSent(responses.filter(x => x.status === "Sent").map(y => y.agreementNumber));
        setApproved(responses
            .filter(x => x.status === "Approved" || x.status === "Paid")
            .map(y => y.agreementNumber));
        setDeclined(responses.filter(x => x.status === "Declined").map(y => y.agreementNumber));
        setLogRetrived(true);
    };
    const handleExpand = async (contracts) => {
        if (applicationInformation) {
            contracts = contracts.filter(x => !applicationInformation.applications.some(y => y.contractNumber === x));
        }
        setRetriving(true);
        if (!getApplicationInformation || contracts.length === 0)
            return;
        const response = await getApplicationInformation(contracts);
        if (response && response.applications)
            setApplicationInformation(response);
        setRetriving(false);
    };
    React.useEffect(() => {
        handleGetLog(Object.entries(groupBy(commissions, c => c.agreementNumber)).map(([x, list]) => {
            return x;
        }));
    });
    let agreements = Object.entries(groupBy(commissions, c => c.agreementNumber)).map(([x, list]) => {
        var sum = Math.round(list.reduce((a, b) => {
            const { upfrontAmount = 0, marginAmount = 0, billCommissionAmount = 0 } = b;
            return a + upfrontAmount + marginAmount + billCommissionAmount;
        }, 0));
        const obj = {
            agreementNumber: x,
            amount: sum,
            date: monthDate,
            agreementType: list[0].agreementType
        };
        let status = "";
        if (approved.includes(x))
            status = "Godkjent";
        else if (declined.includes(x))
            status = "Avslått";
        else if (sent.includes(x))
            status = "Avventer godkjenning";
        return (_jsxs(Box, { p: 1, style: { display: "inline-flex" }, children: [sendToApproval && (_jsx(Checkbox, { checked: sent.includes(x) ||
                        approved.includes(x) ||
                        send.some(y => x === y.agreementNumber), onChange: () => handleCheck(obj), disabled: sent.includes(x) || approved.includes(x) })), !!sendToApproval ? (_jsxs(Accordion, { elevation: 0, onChange: () => handleExpand(Object.keys(groupBy(list, c => c.contractNumber))), children: [_jsx(AccordionSummary, { expandIcon: _jsx(ExpandMoreIcon, {}), children: _jsxs(Typography, { variant: "h6", children: [_jsx(Box, { p: 1, component: "span", fontWeight: "fontWeightBold", children: list[0].agreementType }), _jsx(Box, { p: 1, component: "span", fontWeight: "fontWeightBold", children: _jsx(FormattedNumber, { value: sum, format: "currency" }) }), _jsx(Box, { p: 1, component: "span", fontWeight: "fontWeightBold", children: status })] }) }), _jsx(AccordionDetails, { children: _jsx(DataTable, { options: {
                                    search: false,
                                    showTitle: false,
                                    paging: false,
                                    emptyRowsWhenPaging: false,
                                    toolbar: false
                                }, columns: [
                                    { title: "Selger", field: "salespersonName" },
                                    { title: "Kontraktnr.", field: "contractNumber" },
                                    {
                                        title: "Saksnr.",
                                        render: row => retriving ? (_jsx(CircularProgress, { size: 10 })) : applicationInformation &&
                                            applicationInformation.applications &&
                                            applicationInformation.applications.some(t => t.contractNumber === row.contractNumber) ? (_jsx(Box, { children: applicationInformation.applications.filter(t => t.contractNumber === row.contractNumber)[0].applicationNumber })) : null
                                    },
                                    {
                                        title: "Reg.nr.",
                                        render: row => retriving ? (_jsx(CircularProgress, { size: 10 })) : applicationInformation &&
                                            applicationInformation.applications &&
                                            applicationInformation.applications.some(t => t.contractNumber === row.contractNumber) ? (_jsx(Box, { children: applicationInformation.applications.filter(t => t.contractNumber === row.contractNumber)[0].regNumber })) : null
                                    },
                                    { title: "Kunde", field: "customerName" },
                                    {
                                        title: "Upfront",
                                        field: "upfrontAmount",
                                        render: row => row.upfrontAmount ? (_jsx(FormattedNumber, { value: row.upfrontAmount, format: "currency" })) : null
                                    },
                                    {
                                        title: "Stykk",
                                        field: "billCommissionAmount",
                                        render: row => row.billCommissionAmount ? (_jsx(FormattedNumber, { value: row.billCommissionAmount, format: "currency" })) : null
                                    },
                                    {
                                        title: "Periodisk",
                                        field: "marginAmount",
                                        render: row => row.marginAmount ? (_jsx(FormattedNumber, { value: row.marginAmount && row.marginAmount, format: "currency" })) : null
                                    }
                                ], data: list }) })] })) : (_jsx(_Fragment, { children: _jsxs(Typography, { variant: "h6", children: [_jsx(Box, { p: 1, component: "span", fontWeight: "fontWeightBold", children: list[0].agreementType }), _jsx(Box, { p: 1, component: "span", fontWeight: "fontWeightBold", children: _jsx(FormattedNumber, { value: sum, format: "currency" }) }), _jsx(Box, { p: 1, component: "span", fontWeight: "fontWeightBold", children: status })] }) }))] }, x));
    });
    return (_jsxs(Box, { p: 1, children: [agreements, sendToApproval && (_jsx(Button, { color: "primary", variant: "contained", onClick: () => handleSendToApproval(), disabled: loading || send.length === 0, children: "Send til avregning" })), loading && (_jsxs(Box, { p: 1, component: "span", children: [_jsx(CircularProgress, { size: 30 }), " "] })), message && (_jsx(Box, { p: 1, component: "span", children: message }))] }));
};
//# sourceMappingURL=TableStructure.js.map